import Vue from 'vue';
import App from './index.vue';
import store from '../../vue-search-page/store';

const vueInputSearch = document.querySelector('#input-search');
if (vueInputSearch) {
  new Vue({
    store,
    el: vueInputSearch,
    render(h) {
      return h(App);
    },
  });
}
